
import { Component, Vue, Watch } from "vue-property-decorator";
import ExamList from "@/lib/model/exam/exam";
import Auth from "@/lib/common/auth";
import vuexStore from "@/store/vuex-store";
import CandidateCreateForm from "@/lib/form/candidate/CandidateCreateForm";
import ModalTitle from "@/lib/model/exam/modal-title";
import ModalHeader from "@/components/modal-header.vue";
import ExamListForm, { UploadParamsForm } from "@/lib/form/exam/ExamListForm";
import { ExamInfo, StructExam } from "@/lib/model/exam/exam";
import { StructParam } from "@/lib/form/candidate/CandidateCreateForm";
import Candidate, {
  CandidateMCreateParams,
  CandidateParam
} from "@/lib/model/exam/candidate";
import ExamLink from "@/components/modal-examlink-joblink.vue";
import { CandidateListExportParams } from "@/lib/model/exam/candidate";
import config from "@/config/config";
import _ from "lodash-es";
import { CandidateMCreateParseParams } from "../../lib/model/exam/candidate";
import gateway from "@/lib/request/gateway";
import AddOneCandidateModal from "./components/add-one-candidate-new.vue";
import AddMoreCandidateModal from "./components/add-more-candidate-new.vue";
import CopyExamModal from "./components/copy-exam-modal.vue";
import DelExamModal from "./components/del-exam-modal.vue";
import AsyncDownloadModal from "./components/async-download-modal.vue";
import TimeUtil from "@/lib/common/time-util";
import CandidateExportForm from "@/lib/form/candidate/CandidateExportForm";
import dayjs from "dayjs";
import track from "@/lib/common/track";
import secondAsk from "@/views/ai-builder/components/delete-dialog.vue";
import {
  ExamCopyForm,
  ExamDeleteForm,
  ExamGetForm
} from "@/lib/form/exam/ExamListForm";
import Config from "@/config/config";
import sensors from "@/lib/thirdparty/sensorsdata.min";
import { CompanyConfig } from "@/lib/common/acm";
import Loading from "../../components/loading.vue";
import ExamName from "./components/exam-name.vue";
import Power from "./components/power.vue";
import PowerCopy from "./components/power-copy.vue";
import { ExamV2Custom } from "@/lib/model/exambuilder/exam-v2";
import SelectTemp from "@/views/message/components/select-temp.vue";
import TemplateDialog from "./templateDialog.vue";
import AdminConfig from "./config/config.vue";
import SetResult from "./components/setResult.vue";
import MassUpload from "@/views/paper/list-mass-upload.vue";
import AIQaConfig from "@/views/ai-qa-officer/components/ai-qa-config.vue";
import CopyExamAutoRule from "./components/copy-exam-auto-rule.vue";

import ExamV3Custom, {
  ExamVDList,
  ExamVDListRequest,
  ExamVDVersionListRequest,
  ExamVDCandidateCount,
  ExamVDCandidateItem,
  ExamVDCandidateCountRequest,
  ExamV3
} from "@/lib/model/exambuilder/exam-v3/exam-v3";
import {
  ExamItem,
  BasicInformation
} from "@/lib/model/exambuilder/exam-v3/exam-v3-sub";
import Item from "@/lib/model/breadcrumb/item";
import { Report as CertiCode } from "@/lib/model/exam/candidate";
import { isShunfengCompany } from "@/utils/sf";

enum examStatusEnum {
  "全部",
  "未开始",
  "进行中",
  "已结束"
}

export class Search {
  status = 0;
  name = "";
  remark = "";
  createdTime: string[] = [];
  lastUpdateTime: string[] = [];
}

class PageSizeOptions {
  value = 10;
}

class TableList extends ExamList {
  hasChildren = false;
  isSubVersion = false;
  isLast = false;
}

@Component({
  components: {
    CopyExamAutoRule,
    AIQaConfig,
    ModalHeader,
    ExamLink,
    AddOneCandidateModal,
    AddMoreCandidateModal,
    CopyExamModal,
    DelExamModal,
    Loading,
    AsyncDownloadModal,
    ExamName,
    Power,
    PowerCopy,
    SelectTemp,
    TemplateDialog,
    AdminConfig,
    SetResult,
    secondAsk,
    MassUpload
  }
})
export default class AiList extends Vue {
  name = "AiList";
  listForm: ExamListForm = new ExamListForm();
  list: TableList[] = new Array<TableList>();
  targetRow = new ExamList();
  showWord = true;
  search: Search = new Search();
  total = 0;
  loading = false;
  tableLoading = true;
  address = "";
  addressImage = "data:image/png;base64,";
  hasLoad = false;
  showTemp = false;
  rowStyle = {
    color: "#8B8F94",
    "font-weight": "400",
    "font-size": "14px"
  };
  modal = {
    copy: false,
    tag: false,
    address: false
  };
  page = 1;
  rules = {
    name: [{ required: true, message: "请输入面试名称", trigger: "change" }]
  };
  settingForm = {};
  isShowAddOne = false;
  isShowAddMore = false;
  candidateCreateForm = new CandidateCreateForm();
  candidateExportForm = new CandidateExportForm();
  link = "";
  scanLink = "";
  scanUrl = "";
  modalTitle: ModalTitle = new ModalTitle();
  examGetForm: ExamGetForm = new ExamGetForm();
  structParams: StructParam[] = new Array<StructParam>();
  showExamUrl = false;
  candidateExportParams = new CandidateListExportParams();
  isShowCopyModal = false;
  isShowDelModal = false;
  examCopyForm = new ExamCopyForm();
  examDeleteForm = new ExamDeleteForm();
  uploadParams = new UploadParamsForm();
  candidateMCreateParseParams = new CandidateMCreateParseParams();
  candidateMCreateParams = new CandidateMCreateParams();
  currentPageSize = 10;
  V = vuexStore;
  showTemplateDialog = false;
  pageSizeOptions: PageSizeOptions[] = [
    { value: 10 },
    { value: 20 },
    { value: 50 },
    { value: 100 }
  ];
  examList: ExamList = new ExamList();
  examName = "";
  examRemark = "";
  currentCompanyId = 0;
  isShowExportAll = false;
  showExportAllButton = false;
  exportLoading = false;
  isWorker = false; //普工版
  isYD = false; //友达光电
  loadingList = true;
  isShowDownloadModal = false;
  currentPaperId = 0; // 当前点击列的面试ID，神策打点用
  showEditName = false;
  editNameParam = {
    examId: 0,
    name: "",
    remark: ""
  };
  massUpload = {
    companyId: "",
    examId: ""
  };
  connectCode = "";
  paperIdInAdd = 0; //添加候选人弹窗用面试id
  showPower = false;
  showSetResult = false;
  secondAskDialogOfCancel = false;
  massActiveRow = {};
  massUploadShow = false;
  uploadExcelId = "";
  rowExam: any = {};
  useReportCertiCode = false;
  reportCertiCode = "";
  loadingCertiCode = false;

  @Watch("useReportCertiCode")
  changeUseReportCertiCode(val: boolean) {
    if (!val) {
      this.reportCertiCode = "";
      return;
    }
    if (this.loadingCertiCode) return;
    this.loadingCertiCode = true;
    //获取提取码
    CertiCode.getDefaultCode({ examId: this.paperIdInAdd }).then((res: any) => {
      this.reportCertiCode = res.reportCertiCode;
      this.loadingCertiCode = false;
    });
  }

  reportCertiCodeSubmit() {
    CertiCode.save({
      examId: this.paperIdInAdd,
      reportCertiCode: this.reportCertiCode
    }).then((res: any) => {
      this.$message.success("设置成功");
      this.showReportCertiCodeDialog = false;
    });
  }
  copyCertiCode() {
    if (!this.reportCertiCode) return;
    window.navigator.clipboard.writeText(this.reportCertiCode).then(() => {
      this.$message.success("复制成功");
    });
  }

  //91514临时禁用
  get tempNotAllow() {
    // return ["91514", "80978"].includes(Auth.companyId);
    // return false;
    return !this.$P.exam.edit;
  }

  //内部使用 设置web页
  get setWeb(): boolean {
    return this.$route?.query?.teamUse === "setWeb";
  }

  // 表格类名
  get tableClass() {
    return `MainRowClass ${this.setWeb ? "setWebTable" : ""}`;
  }

  getRowKey(row: ExamItem) {
    return "" + row.examId + row.examVersionId;
  }

  load(tree: any, treeNode: any, resolve: any) {
    ExamVDList.getVersionList(
      new ExamVDVersionListRequest().assign({ examId: tree.examId })
    ).then((res: any) => {
      const len = res.data.list.length;
      const list = res.data.list.map((item: any, index: number) => {
        return new TableList().assign({
          positionName: tree.positionName,
          name: "批次" + (len - index),
          joinStatus: tree.joinStatus,
          candidateNumber: item.candidateCount.all,
          hasChildren: false,
          examId: item.examVersionId, // setWeb下展示
          examIdForSetWeb: tree.examIdForSetWeb, // setWeb下展示
          examBeginTogether: tree.examBeginTogether,
          noEnding: tree.noEnding,
          endTime: tree.endTime,
          beginTime: tree.beginTime,
          createdTime: item.createdTime,
          lastUpdateTime: item.lastUpdateTime,
          examVersionId: item.examVersionId,
          questionNumber: item.questionNumber,
          useTimeSecond: item.useTimeSecond,
          isLast: index === 0,
          isSubVersion: true,
          fatherExamId: tree.examId,
          isNoCreateOpenJoin: item.isNoCreateOpenJoin
        });
      });
      resolve(list);
    });
  }
  showReportCertiCodeButtion = false;
  created() {
    this.modalTitle.title = "添加一位候选人";
    this.modalTitle.hasDesc = true;
    this.modalTitle.desc = "肯德基餐厅储备经理校招-WJW36";
    this.currentPageSize =
      parseInt(Auth.currentPageSize) > 0 ? parseInt(Auth.currentPageSize) : 10;
    const cookieUserId = Auth.userId;
    const storeUserId = this.V.user.id;
    if (cookieUserId !== storeUserId) {
      Auth.userId = storeUserId;
    }

    this.tableLoading = true;
    // document.title = "海纳AI面试";
    if (Auth.token) {
      TimeUtil.sleep(500).then(() => {
        const companyConfig = CompanyConfig.getInstance();
        this.showExportAllButton = companyConfig.showExportAllButton == 1;
        this.isWorker = this.V.isWorker;
        this.isYD = ["194", "91415"].includes(Auth.companyId);

        this.getList();
      });
      // if (parseInt(this.V.user.threatDegree) <= 7) {
      //   this.getList();
      // } else {
      //   this.$router.push("/no-auth").catch(err => err);
      // }
    } else {
      this.$router.push("/").catch(err => err);
    }
    const companyConfig = CompanyConfig.getInstance();
    this.showExportAllButton = companyConfig.showExportAllButton == 1;
    this.showReportCertiCodeButtion =
      this.V.companyPower.enableReportCertiCode === 1;
    this.isWorker = this.V.isWorker;
    // [90528, 91359, 91237, 91415, 1010, 173, 194].includes(
    //   companyConfig.companyId
    // ) || CompanyConfig.getInstance().isTestExamCompany === 1;
  }

  addpaperTemp() {
    this.$router.push("/ai-builder-component");
  }

  sfRouterAddExam() {
    // 顺丰特判：通用版上新增面试
    if (isShunfengCompany(Auth.companyId)) {
      //AIbuilder通用
      this.$router.push("/ai-builder");
    } else {
      //旧版
      this.$router.push("/paper-info");
    }
  }

  sfRouterEditExam(row: any) {
    console.log("🚀 ~ AiList ~ sfRouterPaperInfo ~ companyId:", Auth.companyId);
    // 顺丰特判：通用版上跳转到面试编辑
    if (isShunfengCompany(Auth.companyId)) {
      this.$router.push({
        name: "ai-builder",
        query: { paperId: row.examId, cid: Auth.companyId, step: "4" }
      });
    } else {
      this.$router.push(
        `/paper-info?paperId=${row.examId}&status=add&cid=${Auth.companyId}`
      );
    }
  }

  sfRouterQuestionEdit(row: any) {
    console.log("🚀 ~ AiList ~ sfRouterPaperInfo ~ companyId:", Auth.companyId);
    // 顺丰特判：通用版上跳转到题目设置
    if (isShunfengCompany(Auth.companyId)) {
      this.$router.push({
        name: "ai-builder",
        query: { paperId: row.examId, cid: Auth.companyId, step: "2" }
      });
    } else {
      this.$router.push(
        `/question-paper?paperId=${row.examId}&from=edit&canEdit=${row.closeUpdate}`
      );
    }
  }

  addPaper() {
    if (this.V.isWorker) {
      //Aibuilder普工
      this.$router.push("/ai-builder-worker");
    } else if (this.V.isNewAi) {
      //AIbuilder通用
      this.$router.push("/ai-builder");
    } else {
      //旧版
      this.sfRouterAddExam();
    }
  }
  addPaperNew() {
    this.$router.push("/aihr-builder");
  }

  showExportAll() {
    this.isShowExportAll = true;
    this.modalTitle.title = "";
    this.modalTitle.hasDesc = false;
  }

  handleExportAllClose() {
    this.isShowExportAll = false;
  }

  exportAll() {
    if (
      this.candidateExportForm.submitTimeStart == "" &&
      this.candidateExportForm.submitTimeStop == ""
    ) {
      this.$message.error("请选择面试时间");
      return;
    } else if (this.candidateExportForm.submitTimeStart == "") {
      this.$message.error("请选择面试开始时间");
      return;
    } else if (this.candidateExportForm.submitTimeStop == "") {
      this.$message.error("请选择面试结束时间");
      return;
    } else {
      this.candidateExportForm.submitTimeStart = dayjs(
        this.candidateExportForm.submitTimeStart
      ).format("YYYY-MM-DD HH:mm:ss");
      this.candidateExportForm.submitTimeStop = dayjs(
        this.candidateExportForm.submitTimeStop
      ).format("YYYY-MM-DD HH:mm:ss");
      if (
        this.candidateExportForm.submitTimeStart >
        this.candidateExportForm.submitTimeStop
      ) {
        this.$message.error("面试时间选择有误");
        return false;
      }
    }

    this.candidateExportForm.companyId = this.currentCompanyId;
    const companyConfig = CompanyConfig.getInstance();
    this.exportLoading = true;
    switch (Number(companyConfig.exportCandidateType)) {
      case 1:
        Candidate.kfcCandidateAllExport(this.candidateExportForm)
          .then(res => {
            if (res.code === 0) {
              if (res.data.isAsync === 1) {
                this.isShowDownloadModal = true;
              } else {
                const dataUrl = res.data.ossUrl;
                const a = document.createElement("a");
                a.href = dataUrl;
                a.setAttribute("download", "候选人列表");
                a.click();
              }
            } else {
              this.$message.error("导出失败");
            }
          })
          .finally(() => {
            this.isShowExportAll = false;
            this.exportLoading = false;
          });
        break;
      case 2:
        Candidate.mklCandidateAllExport(this.candidateExportForm)
          .then(res => {
            if (res.code === 0) {
              if (res.data.isAsync === 1) {
                // 异步导出
                this.isShowDownloadModal = true;
              } else {
                const dataUrl = res.data.ossUrl;
                const a = document.createElement("a");
                a.href = dataUrl;
                a.setAttribute("download", "候选人列表");
                a.click();
              }
            } else {
              this.$message.error("导出失败");
            }
          })
          .finally(() => {
            this.isShowExportAll = false;
            this.exportLoading = false;
          });
        break;
      default:
        Candidate.candidateAllExport(this.candidateExportForm)
          .then(res => {
            if (res.code === 0) {
              if (res.data.isAsync === 1) {
                this.isShowDownloadModal = true;
              } else {
                const dataUrl = res.data.ossUrl;
                const a = document.createElement("a");
                a.href = dataUrl;
                a.setAttribute("download", "候选人列表");
                a.click();
              }
            } else {
              this.$message.error("导出失败");
            }
          })
          .finally(() => {
            this.isShowExportAll = false;
            this.exportLoading = false;
          });
        break;
    }
  }

  addCancel() {
    this.isShowAddOne = false;
    this.getList();
  }

  addSubmit() {
    track("click_add_candidate", {
      exam_id: this.candidateMCreateParams.examId,
      exam_name: this.examName,
      exam_remark: this.examRemark,
      add_type: "添加一位",
      operation_type: "按钮点击",
      operation_name: "完成",
      click_from: "AI面试列表页"
    });
    this.getList();
    this.isShowAddOne = false;
  }

  handleUrlClose() {
    this.showExamUrl = false;
  }

  downloadClose() {
    this.isShowDownloadModal = false;
  }

  addSubmitContinue() {
    this.isShowAddOne = false;
  }

  addMoreCancel() {
    this.isShowAddMore = false;
  }

  addMoreSubmit() {
    this.isShowAddMore = false;
  }

  handleMoreClose() {
    track("click_add_candidate", {
      exam_id: this.candidateMCreateParams.examId,
      exam_name: this.examName,
      exam_remark: this.examRemark,
      add_type: "批量添加",
      operation_type: "按钮点击",
      operation_name: "导入",
      click_from: "AI面试列表页"
    });
    this.getList();
    this.isShowAddOne = false;
    this.isShowAddMore = false;
  }

  handleOneClose() {
    this.getList();
    this.isShowAddMore = false;
    this.isShowAddOne = false;
  }

  watchSub(row: any) {
    console.log(row);
  }
  showCopyMultiExam = false;
  showReportCertiCodeDialog = false;
  async show(scence: string, row: any) {
    if (scence === "reportCertiCode") {
      this.paperIdInAdd = Number(row.examId);
      const res = await CertiCode.getCertiCode({
        examId: this.paperIdInAdd
      });
      this.reportCertiCode = res.reportCertiCode;
      this.useReportCertiCode = Boolean(this.reportCertiCode);
      this.showReportCertiCodeDialog = true;
      return;
    }
    if (scence === "copyMultiExam") {
      //批量复制面试
      this.paperIdInAdd = Number(row.examId);
      this.examCopyForm.companyId = parseInt(Auth.companyId);
      this.examCopyForm.name = row.name;
      this.examCopyForm.examId = row.examId;
      this.showCopyMultiExam = true;
      this.examName = row.name;
      return;
    }
    if (scence === "batchInterviewerRatings") {
      // 批量导入面试官打分
      this.massActiveRow = row;
      this.massUploadShow = true;
      console.log(this.uploadExcelId, "this.uploadExcelIdthis.uploadExcelId");
      this.$nextTick(() => {
        // if (this.uploadExcelId) {
        //   ExamList.mAuditCheck({ taskId: this.uploadExcelId }).then(res => {
        //     const { successNumber, totalNumber, failNumber } = res;
        //     if (successNumber + failNumber === totalNumber) {
        (this.$refs.massUpload as Vue & {
          reloadData: Function;
        }).reloadData();
        // this.$refs.massUpload.reloadData();
        //   }
        // });
        // }
      });
      return;
    }
    if (scence === "clearInterviewerMark") {
      this.secondAskDialogOfCancel = true;
      this.massUpload.companyId = row.companyId;
      this.massUpload.examId = row.examId;
      console.log(this.massUpload);
      return;
    }
    if (scence === "watchSub" && this.setWeb) {
      return;
    }
    console.log("row: ", row);
    this.modalTitle.hasDesc = true;
    this.modalTitle.desc = row.name;
    this.examName = row.name;
    this.examRemark = row.remark;
    if (scence === "editName") {
      this.editNameParam = {
        name: row.name,
        remark: row.remark,
        examId: row.examId
      };
      this.showEditName = true;
      //
    } else if (scence === "address") {
      if (row.canOpenJoin === 2) return;
      this.currentPaperId = row.examId;
      if (!this.$P.person.link) return;
      track("exam_page_interact", {
        exam_id: row.examId,
        exam_name: row.name,
        exam_remark: row.remark,
        operation_type: "按钮点击",
        operation_name: "面试链接"
      });

      // 神策埋点
      track("click_exam_link", {
        exam_id: row.examId,
        exam_name: row.name,
        is_click: true,
        operation_type: "按钮点击",
        operation_name: "点击面试链接按钮"
      });

      // 面试链接dialog
      this.examGetForm.examId = row.examId;
      this.examGetForm.companyId = parseInt(Auth.companyId);
      ExamList.wsaCode(this.examGetForm)
        .then(res => {
          if (res.code === 0) {
            this.scanLink = res.data.base64string
              ? "data:image/png;base64," + res.data.base64string
              : "";
            // this.scanUrl = `${Config.aiInterviewHost}/exam/sign?connectCode=${row.connectCode}`;
            this.modalTitle.title = "面试链接";
            this.connectCode = String(row.connectCode);
            this.rowExam = row;
            this.showExamUrl = true;
          }
        })
        .then(() => {
          ExamList.examUrl(this.examGetForm).then(urlRes => {
            if (urlRes.code === 0) {
              this.scanUrl = urlRes.data.url;
            }
          });
        });
    } else if (scence === "examSetting") {
      track("exam_page_interact", {
        exam_id: row.examId,
        exam_name: row.name,
        exam_remark: row.remark,
        operation_type: "按钮点击",
        operation_name: "面试设置"
      });
      if (this.V.isWorker) {
        //AIbuilder 普工版
        this.$router.push({
          name: "ai-builder-worker",
          query: { paperId: row.examId, cid: Auth.companyId, step: "1" }
        });
      } else if (this.V.isNewAi) {
        //新版AIbuilder流程
        this.$router.push({
          name: "ai-builder",
          query: { paperId: row.examId, cid: Auth.companyId, step: "4" }
        });
      } else {
        this.sfRouterEditExam(row);
      }
    } else if (scence === "bgCheckSetting") {
      track("exam_page_interact", {
        exam_id: row.examId,
        exam_name: row.name,
        exam_remark: row.remark,
        operation_type: "按钮点击",
        operation_name: "背调设置"
      });
      this.$router.push(
        `/paper-bgcheck?paperId=${row.examId}&status=add&step=2`
      );
    } else if (scence === "bgCheckSetting") {
      track("exam_page_interact", {
        exam_id: row.examId,
        exam_name: row.name,
        exam_remark: row.remark,
        operation_type: "按钮点击",
        operation_name: "背调设置"
      });
      this.$router.push(
        `/paper-bgcheck?paperId=${row.examId}&status=edit&step=2&back=list`
      );
    } else if (scence === "paperEdit") {
      if (this.tempNotAllow) {
        return;
      }
      track("exam_page_interact", {
        exam_id: row.examId,
        exam_name: row.name,
        exam_remark: row.remark,
        operation_type: "按钮点击",
        operation_name: "编辑题目"
      });
      if (this.V.isWorker) {
        //新版AIbuilder  普工版
        this.$router.push({
          name: "ai-builder-worker",
          query: { paperId: row.examId, cid: Auth.companyId, step: "0" }
        });
      } else if (this.V.isNewAi) {
        //新版AIbuilder流程
        this.$router.push({
          name: "ai-builder",
          query: { paperId: row.examId, cid: Auth.companyId, step: "2" }
        });
      } else {
        this.sfRouterQuestionEdit(row);
      }
    } else if (scence === "export") {
      track("exam_page_interact", {
        exam_id: row.examId,
        exam_name: row.name,
        exam_remark: row.remark,
        operation_type: "按钮点击",
        operation_name: "导出候选人"
      });
      // 神策埋点
      track("click_export_candidate", {
        operation_type: "按钮点击",
        operation_name: "导出候选人",
        click_from: "AI面试列表页"
      });
      this.candidateExportParams.companyId = parseInt(Auth.companyId);
      this.candidateExportParams.examId = row.examId;
      this.candidateExportParams.asCompany = 0;
      this.candidateExportParams.isFsk = this.isYD ? 1 : 0;
      this.tableLoading = true;
      Candidate.candidateListExport(this.candidateExportParams)
        .then(res => {
          if (res.code === 0) {
            if (res.data.isAsync === 1) {
              this.isShowDownloadModal = true;
            } else {
              const dataUrl = res.data.ossUrl;
              const a = document.createElement("a");
              a.href = dataUrl;
              a.setAttribute("download", "候选人列表");
              a.click();
            }
          }
        })
        .finally(() => {
          this.tableLoading = false;
        });
    } else if (scence === "power") {
      this.paperIdInAdd = Number(row.examId);
      this.showPower = true;
    } else if (scence === "result") {
      this.paperIdInAdd = Number(row.examId);
      this.targetRow = row;
      this.showSetResult = true;
    } else if (scence === "temp") {
      this.paperIdInAdd = Number(row.examId);
      this.examName = row.name;
      this.showTemp = true;
    } else if (scence === "copy") {
      track("exam_page_interact", {
        exam_id: row.examId,
        exam_name: row.name,
        exam_remark: row.remark,
        operation_type: "按钮点击",
        operation_name: "复制面试"
      });
      this.modalTitle.title = "复制面试";
      this.examCopyForm.companyId = parseInt(Auth.companyId);
      this.examCopyForm.name = row.name;
      this.examCopyForm.examId = row.examId;
      this.isShowCopyModal = true;
    } else if (scence === "remove") {
      track("exam_page_interact", {
        exam_id: row.examId,
        exam_name: row.name,
        exam_remark: row.remark,
        operation_type: "按钮点击",
        operation_name: "删除面试"
      });
      this.editNameParam = {
        name: row.name,
        remark: row.remark,
        examId: row.examId
      };
      // this.$confirm(
      //   "删除面试将同时删除该面试下所有候选人记录，确定要删除本场面试吗？",
      //   "删除面试",
      //   {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     type: "warning"
      //   }
      // ).then(() => {
      //   this.examDeleteForm.companyId = parseInt(Auth.companyId);
      //   this.examDeleteForm.examId = row.examId;
      //   ExamList.examDelete(this.examDeleteForm).then(res => {
      //     if (res.code === 0) {
      //       this.getList();
      //     }
      //   });
      // });
      this.examDeleteForm.companyId = parseInt(Auth.companyId);
      this.examDeleteForm.examId = row.examId;
      this.modalTitle.hasDesc = false;
      this.modalTitle.title = "删除面试";
      this.isShowDelModal = true;
    } else if (scence === "ask") {
      track("exam_page_interact", {
        exam_id: row.examId,
        exam_name: row.name,
        exam_remark: row.remark,
        operation_type: "按钮点击",
        operation_name: "调查问卷结果统计"
      });
      this.$router.push(
        `/ask-paper?companyId=${Auth.companyId}&examId=${row.examId}`
      );
      // AI答疑官面试设置
    } else if (scence === "aiQaConfig") {
      this.aiQaConfig(row);
      return;
    } else if (scence === "copyAutoRule") {
      this.copyAutoRule(row);
    } else {
      //候选人列表
      this.$router.push(
        `/exam-paperList/${row.examId}?companyId=${Auth.companyId}`
      );
    }
  }
  // AI答疑官面试设置
  aiQaConfigVisible = false;
  aiQaConfigData = {
    examId: 0
  };
  aiQaConfig(row: any) {
    this.aiQaConfigData.examId = row.examId;
    this.aiQaConfigVisible = true;
  }

  // 复制自动化规则
  isShowCopyExamAutoRuleModal = false;
  copyExamAutoRuleForm = {
    fromExamVersionId: 0,
    targetExamVersionIds: []
  };

  copyAutoRule(row: any) {
    this.copyExamAutoRuleForm = {
      fromExamVersionId: row.examId,
      targetExamVersionIds: []
    };
    this.isShowCopyExamAutoRuleModal = true;
  }

  copyExamAutoRuleOK(params: any) {
    this.isShowCopyExamAutoRuleModal = false;
  }

  //点击面试列表 某一行 进入候选人列表
  clickTableRow(row: any, column: any, event: any) {
    if (row.isSubVersion) {
      return;
    }
    this.$router.push(
      `/exam-paperList/${row?.examId}?companyId=${Auth.companyId}`
    );
  }

  delCancel() {
    this.isShowDelModal = false;
  }

  delSuccess() {
    ExamList[
      this.V.isWorker
        ? "examDeleteWorker"
        : this.V.isNewAi || isShunfengCompany(Auth.companyId)
        ? "examDeleteAi"
        : "examDelete"
    ](this.examDeleteForm).then(res => {
      if (res.code === 0) {
        this.isShowDelModal = false;
        this.$message.success("删除成功");
        this.getList();
      }
    });
  }

  copySuccess() {
    this.getList();
    this.isShowCopyModal = false;
  }

  copyCancel() {
    this.isShowCopyModal = false;
  }

  showAdd(event: string, row: ExamList) {
    this.modalTitle.desc = row.name;
    this.examName = row.name;
    this.examRemark = row.remark;
    this.examGetForm.examId = row.examId;
    this.examGetForm.companyId = parseInt(Auth.companyId);
    this.uploadParams.ucCompanyId = parseInt(Auth.companyId);
    this.uploadParams.examId = row.examId;
    this.candidateMCreateParseParams.companyId = parseInt(Auth.companyId);
    this.candidateMCreateParseParams.examId = row.examId;
    this.candidateMCreateParams.examId = String(row.examId);
    this.candidateMCreateParams.companyId = Auth.companyId;
    this.paperIdInAdd = Number(row.examId);

    if (event == "showAddOne") {
      track("exam_page_interact", {
        exam_id: this.examGetForm.examId,
        exam_name: this.examName,
        exam_remark: this.examRemark,
        operation_type: "按钮点击",
        operation_name: "添加一位候选人"
      });
      this.modalTitle.title = "添加一位候选人";
      ExamList.examGet(this.examGetForm)
        .then(res => {
          this.candidateCreateForm.paramList = res.paramList.filter(
            (e: StructParam) => {
              return e.isShow == 1;
            }
          );
          this.candidateCreateForm.companyId = this.examGetForm.companyId;
          this.candidateCreateForm.examId = this.examGetForm.examId;
        })
        .finally(() => {
          this.isShowAddMore = false;
          this.isShowAddOne = true;
        });
    } else if (event === "showAddMore") {
      track("exam_page_interact", {
        exam_id: this.examGetForm.examId,
        exam_name: this.examName,
        exam_remark: this.examRemark,
        operation_type: "按钮点击",
        operation_name: "批量添加候选人"
      });
      this.modalTitle.title = "批量添加候选人";
      this.isShowAddOne = false;
      this.isShowAddMore = true;
    }
  }
  sensorTrack(operation_type: string) {
    try {
      let operation_name = "";
      if (operation_type == "搜索") {
        operation_name = this.search.name;
      } else if (operation_type == "筛选") {
        operation_name = examStatusEnum[this.search.status];
      }
      track("exam_page_interact", {
        exam_id: this.examGetForm.examId,
        exam_name: this.examName,
        exam_remark: this.examRemark,
        operation_type: operation_type,
        operation_name: operation_name
      });
    } catch (e) {
      console.log(e);
    }
    return true;
  }

  getList(param = "") {
    this.loadingList = true;
    this.currentCompanyId = parseInt(Auth.companyId);
    this.tableLoading = true;
    const getListForm = new ExamListForm();
    if (isShunfengCompany(Auth.companyId)) {
      getListForm.examTypeList = ["aibuilder"];
    }
    // getListForm.userId = parseInt(Auth.userId);
    if (param === "pageSize" || param == "search-name") {
      getListForm.page = 1;
      this.page = 1;
    } else {
      getListForm.page = this.listForm.page;
    }
    if (this.setWeb) {
      getListForm.nameOrRemarkOrExamId = this.search.name;
    } else {
      getListForm.nameOrRemark = this.search.name;
    }
    getListForm.createdTime = this.search.createdTime;
    getListForm.lastUpdateTime = this.search.lastUpdateTime;

    getListForm.pageSize = this.currentPageSize;
    Auth.currentPageSize = String(this.currentPageSize);
    getListForm.companyId = parseInt(Auth.companyId);
    switch (this.search.status) {
      case 1:
        getListForm.beforeStart = 1;
        break;
      case 2:
        getListForm.isPlaying = 1;
        break;
      case 3:
        getListForm.afterEnd = 1;
        break;
    }
    ExamList.getList(getListForm)
      .then(res => {
        this.total = res.count;
        this.list = res.exams.map(item => {
          const newItem = new TableList().assign(item);
          newItem.hasChildren = !!(
            item.examVersionId !== item.examId && item.examVersionId
          );
          return newItem;
        });
        this.loadingList = false;
      })
      .finally(() => {
        this.loadingList = false;
        this.tableLoading = false;
      });
  }

  className(status: number) {
    switch (status) {
      case 1:
        return "green";
      case 2:
        return "blue";
      case 3:
        return "gray";
    }
  }

  // copyLink() {
  //   return;
  // }

  downLoadBarcode() {
    const a = document.createElement("a");
    a.href = this.addressImage;
    a.setAttribute("download", "在线面试二维码");
    a.click();
  }
  //编辑面试名称
  editNameOK(params: any) {
    ExamV2Custom.updateName(params).then((res: any) => {
      if (res.data.code === 0) {
        this.$message.success("修改成功");
        this.getList();
        this.showEditName = false;
      }
    });
    //
  }
  //选择模板
  setTempOK(params: any) {
    this.$message.success("保存成功");
    this.getList();
    this.showTemp = false;
  }
  //面试结果页
  setResultOk(params: any) {
    this.showSetResult = false;
  }
  secondAskDialogOk() {
    ExamList.mAuditClear(this.massUpload).then(res => {
      this.secondAskDialogCancel();
      this.getList();
    });
  }
  secondAskDialogCancel() {
    this.secondAskDialogOfCancel = false;
  }
  massUploadClose() {
    this.massUploadShow = false;
  }
  massUploading(id: any) {
    this.uploadExcelId = id;
  }

  get getTimeOptions() {
    const today = dayjs(new Date()).format("YYYY-MM-DD");
    const todayStartTime = new Date(`${today} 00:00:00`).getTime();
    const endTime = new Date(`${today} 23:59:59`);

    return {
      shortcuts: [
        {
          text: "最近三天",
          onClick: (picker: any) => {
            const start = new Date(todayStartTime - 3600 * 1000 * 24 * 2);
            picker.$emit("pick", [start, endTime]);
          }
        },
        {
          text: "最近一周",
          onClick: (picker: any) => {
            const start = new Date(todayStartTime - 3600 * 1000 * 24 * 6);
            picker.$emit("pick", [start, endTime]);
          }
        },
        {
          text: "最近两周",
          onClick: (picker: any) => {
            const start = new Date(todayStartTime - 3600 * 1000 * 24 * 13);
            picker.$emit("pick", [start, endTime]);
          }
        },
        {
          text: "最近一个月",
          onClick: (picker: any) => {
            const start = new Date(todayStartTime - 3600 * 1000 * 24 * 29);
            picker.$emit("pick", [start, endTime]);
          }
        }
      ]
    };
  }

  // keep-alive 组件 激活时调用
  activated() {
    this.getList("search-name");
  }
}
